module.exports = __webpack_public_path__ + "static/features-slide4@2x-c79bc89216ddea9a044be1e839aacd60.png";